export function getHiddenTicket(idTicket) {
	let ticket = idTicket;
	if (ticket != null && ticket.length > 4) {
		let ln = ticket.length;
		ticket = ticket.substr(0, ln - 4);
		ticket += '****';
	}
	return ticket;
}
